import PricingComponent from "./Component";

const Pricing = () => {
  return <PricingComponent />;
};
export default Pricing;
